<template>
  <div class="coupon-countdown-timer"
       :class="computedClass">
    <div class="countdown-timer__item">
      <span class="number">{{ days }}</span>
      <div class="format">{{ wordString.days }}</div>
    </div>
    <div class="countdown-timer__item">
      <span class="number">{{ hours }}</span>
      <div class="format">{{ wordString.hours }}</div>
    </div>
    <div class="countdown-timer__item">
      <span class="number">{{ minutes }}</span>
      <div class="format">{{ wordString.minutes }}</div>
    </div>
    <div class="countdown-timer__item">
      <span class="number">{{ seconds }}</span>
      <div class="format">{{ wordString.seconds }}</div>
    </div>
  </div>
</template>

<script>
  export default {
    name: "coupon-countdown-timer",
    props: {
      startTime: {type: String},
      endTime: {type: String},
      trans: {type: Object},
      large: {type: Boolean, default: false}
    },
    data() {
      return {
        timer: "",
        wordString: {},
        start: "",
        end: "",
        interval: "",
        days: "",
        minutes: "",
        hours: "",
        seconds: "",
      };
    },
    computed: {
      computedClass() {
        return {
          'coupon-countdown-timer--large': this.large,
          'alert': this.days <= 7,
          'expired': this.days === 0 && this.hours === 0
        }
      }
    },
    methods: {
      timerCount: function (start, end) {
        // Get today's date and time
        let now = new Date().getTime();

        // Find the distance between now an the count down date
        let distance = start - now;
        let passTime = end - now;

        if (distance < 0 && passTime < 0) {
          clearInterval(this.interval);
          this.setTimeToZero();
        } else if (distance < 0 && passTime > 0) {
          this.calcTime(passTime);

        } else if (distance > 0 && passTime > 0) {
          this.calcTime(distance);
        }
      },
      calcTime(dist) {
        // Time calculations for days, hours, minutes and seconds
        this.days = Math.floor(dist / (1000 * 60 * 60 * 24));
        this.hours = Math.floor((dist % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
        this.minutes = Math.floor((dist % (1000 * 60 * 60)) / (1000 * 60));
        this.seconds = Math.floor((dist % (1000 * 60)) / 1000);
      },
      setTimeToZero() {
        this.days = 0;
        this.hours = 0;
        this.minutes = 0;
        this.seconds = 0;
      }
    },
    created: function () {
      this.wordString = this.trans;
    },
    mounted() {
      this.start = new Date(this.startTime).getTime();
      this.end = new Date(this.endTime).getTime();
      // Update the count down every 1 second
      this.timerCount(this.start, this.end);
      this.interval = setInterval(() => {
        this.timerCount(this.start, this.end);
      }, 1000);
    },
  }
</script>

<style lang="scss">
  .coupon-countdown-timer {
    @extend %layout--flex-row-center-x;

    .countdown-timer__item {
      @extend %layout--flex-center-xy;
      @include box-shadow();
      @include border-radius(5px);
      background: color(white);
      width: 47px;
      height: 47px;
      font-size: 18px;
      text-align: center;

      &:not(:last-child) {
        margin-right: 5px;
      }

      .format {
        color: color(gray-400);
        font-size: 12px;
      }
    }

    .number {
      font-weight: 700;
      padding: 0 5px;
      border-radius: 5px;
      display: inline-block;
      text-align: center;
    }

    &.alert {
      .number {
        color: color(crimson);
      }
    }

    &.expired {
      color: color(gray-200);

      .number {
        color: color(gray-200);
      }

      .format {
        color: color(gray-200);
      }
    }

    &--large {
      .countdown-timer__item {
        @include border-radius(radius(normal));
        width: 72.5px;
        height: 72.5px;
        font-size: 24px;

        &:not(:last-child) {
          margin-right: 10px;
        }

        .format {
          color: color(gray-400);
          font-size: 16px;
        }
      }
    }
  }
</style>